/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "checkbook": {
        "nested": {
          "data": {
            "nested": {
              "PrintableCheckStopCause": {
                "values": {
                  "UNKNOWN_STOP_CAUSE": 0,
                  "EXPIRED": 1,
                  "FORCED": 2,
                  "ACCOUNT_CLOSED": 3
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.checkbook?.nested?.data?.nested?.PrintableCheckStopCause) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE PrintableCheckStopCause @ squareup/checkbook/data.proto at 50:1
 */
export const PrintableCheckStopCause = $root.lookupEnum('squareup.checkbook.data.PrintableCheckStopCause').values;